import {
    GETDELETEMANAGEMENTLISTADMIN_SUCCESS,
    GETDELETEMANAGEMENTLISTADMIN_FAILED,
    RESET_GETDELETEMANAGEMENTLISTADMIN,
    LOADING_GETDELETEMANAGEMENTLISTADMIN,
    NETWORK_ERROR_GETDELETEMANAGEMENTLISTADMIN,
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminGetDeleteMgmtList = () => {
    return { type: RESET_GETDELETEMANAGEMENTLISTADMIN };
};

const AdminGetDeleteMgmtLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETDELETEMANAGEMENTLISTADMIN });
    await adminServices
        .post("getDeleteManagementList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(AdminGetDeleteMgmtListsuccess(res.data));
                    break;
                default:
                    dispatch(AdminGetDeleteMgmtListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETDELETEMANAGEMENTLISTADMIN,
                payload: err
            });
        });
};


function AdminGetDeleteMgmtListsuccess(data) {
    return {
        type: GETDELETEMANAGEMENTLISTADMIN_SUCCESS,
        payload: data
    };
}
function AdminGetDeleteMgmtListFailed(data) {
    return {
        type: GETDELETEMANAGEMENTLISTADMIN_FAILED,
        payload: data
    };
}

export { AdminGetDeleteMgmtLists, resetAdminGetDeleteMgmtList }